import { useEffect, useState } from "react";

import useSingleSetting from "../../data/useSingleSetting";

export default function ClickToEdit({
  name,
  children
}: {
  name: string;
  children: React.ReactNode;
}) {
  const { singleSetting } = useSingleSetting("DisableClickToEdit");
  const [canEdit, setCanEdit] = useState(false);

  const disableClickToEdit =
    singleSetting.data?.data?.value?.toLowerCase() === "true";

  useEffect(() => {
    if (!singleSetting.isSuccess) return;
    if (disableClickToEdit) {
      setCanEdit(true);
    }
  }, [singleSetting.isSuccess, disableClickToEdit]);

  return (
    <div className="group relative">
      {!canEdit && (
        <div
          onClick={() => setCanEdit(true)}
          className="
            absolute inset-0 z-10 flex items-center justify-center cursor-pointer
            bg-gray-100/0 group-hover:bg-gray-100/70
            opacity-0 group-hover:opacity-100
            transition-all
          "
        >
          <span className="rounded-md bg-white px-4 py-2 text-sm font-medium text-gray-600 shadow-sm border border-gray-200">
            {`Click to edit ${name}`}
          </span>
        </div>
      )}
      {children}
    </div>
  );
}